<div>
  <router-outlet />
  <ngx-sonner-toaster richColors closeButton />
  <app-import-progress-toast />
  <app-twilio-call-controls />
</div>
